// extracted by mini-css-extract-plugin
module.exports = {"tabMenuContainer":"TabMenu_tabMenuContainer__1vLFR","tabMenuButton":"TabMenu_tabMenuButton__1UVZr","selected":"TabMenu_selected__1vaaC"};